import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.orders')
  .filter('slotWindow', slotWindow);

/* @ngInject */
function slotWindow(splitService, $log, moment) {
  function doFilter(_date) {
    const format = splitService.getDateAndTimeConfig().time;
    return moment(_date).format(format || 'HH:mm');
  }

  function toHours(_milliseconds) {
    const SECOND = 1000,
      MINUTE = 60,
      HOUR = 60;

    return Number(_milliseconds / SECOND / MINUTE / HOUR).toFixed(1)
  }

  return function (_timeSlot) {

    if (!_timeSlot) {
      return;
    }

    const notBefore = _.get(_timeSlot, 'startTime'),
      duration = _.get(_timeSlot, 'duration'),
      notAfter = notBefore + duration;

    if (_.isUndefined(notBefore)) {
      $log.error('Time slot - "startTime" resolved as undefined!');
    }

    return doFilter(notBefore) + ' - ' + doFilter(notAfter);
  }
}
